import { computed } from 'vue';

import { useAccountPropertiesQuery } from '@/modules/QueryClient';

export function useAccountProperties() {
  const accountPropertiesQuery = useAccountPropertiesQuery();

  const accountProperties = computed(() => accountPropertiesQuery.data.value ?? []);

  function getAccountProperty(id: string) {
    return accountProperties.value.find(property => property.id === id);
  }

  return {
    accountProperties,
    getAccountProperty,
  };
}
